export const FORBBIDEN_USERNAMES = ['root', 'admin', 'administrator']
export const FORBBIDEN_EMAILS = ['admin@domain.com', 'root@domain.com']
